import { createContext } from "react";

import type { AuthUser, EffectiveVesselAccess } from "../../types/auth";

/** Current read metadata for one mounted attention route, never a global grant. */
export interface AttentionRegisterAccess {
  user: AuthUser;
  effectiveAccess: EffectiveVesselAccess;
}

export const AttentionRegisterAccessContext = createContext<AttentionRegisterAccess | undefined>(undefined);
